module.exports = __webpack_public_path__ + "static/media/ac-refrigerant-monitor.5aad9d1e.svg";